import { render, staticRenderFns } from "./AppCardNumerador.vue?vue&type=template&id=fb4aa6d0&scoped=true&"
import script from "./AppCardNumerador.vue?vue&type=script&lang=js&"
export * from "./AppCardNumerador.vue?vue&type=script&lang=js&"
import style0 from "./AppCardNumerador.vue?vue&type=style&index=0&id=fb4aa6d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4aa6d0",
  null
  
)

export default component.exports